import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class MonitoramentoService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'monitoramento');
  }

  

  listMonitoramentos(estacaoListOrId, inicio = null, fim = null, status, grupoList = [], clienteList = [], sensorList = [], plu = null, flu = null, integradorList= [], coletorList = []){
    let url = `${this.url_base}/${this.prefixo}`;

    let query: string = '';

    if (Array.isArray(estacaoListOrId) && estacaoListOrId.length > 0) {
      estacaoListOrId.forEach(element => {
        query += `&estacaoList[]=${element}`;
      });
    } else if (this.parametroFiltroValido(estacaoListOrId)) {
      query += '&estacao_id=' + estacaoListOrId;
    }

    if (inicio !== null && inicio !== '') {
      query += '&data_hora_monitoramento=' + inicio;
    }

    if (fim !== null && fim !== '') {
      query += '&data_hora_ultima_situacao=' + fim;
    }

    if (this.parametroFiltroValido(status)) {
      query += '&status=' + status;
    }


    if (grupoList.length > 0) {
      grupoList.forEach(element => {
        query += `&grupoList[]=${element}`;
      });
    }
    if (clienteList.length > 0) {
      clienteList.forEach(element => {
        query += `&clienteList[]=${element}`;
      });
    }
    if (sensorList.length > 0) {
      sensorList.forEach(element => {
        query += `&sensorList[]=${element}`;
      });
    }

    
    if(plu !== null){
      query += `&plu=${plu}`;
    }

    if(flu !== null){
      query += `&flu=${flu}`;
    }

    if (integradorList.length > 0) {
      integradorList.forEach(element => {
        query += `&integradorList[]=${element}`;
      });
    }

    if (coletorList.length > 0) {
      coletorList.forEach(element => {
        query += `&coletorList[]=${element}`;
      });
    }

    
    if (query) {
      url += `?${query.substring(1)}`;
    }

    return this.http.get(url);
  }

  private parametroFiltroValido(valor: any): boolean {
    return valor !== null
      && valor !== undefined
      && valor !== ''
      && valor !== 'null'
      && valor !== 'undefined';
  }
  
  sendEmailMonitoramento(params): Observable<any> {
    let url = `${this.url_base}/${this.prefixo}/send-email`;

    return this.http.post(url, params);
  }

  /**
   * Envia email de uma estação para todos os grupos relacionados
   * POST /api/monitoramento/send-email-estacao
   */
  enviarEmailEstacao(
    estacaoId: number,
    grupoEmailId?: number | null,
    monitoramentoId?: number | null
  ): Observable<any> {
    let url = `${this.url_base}/${this.prefixo}/send-email-estacao`;
    const payload: any = { estacao_id: estacaoId };

    if (grupoEmailId !== undefined && grupoEmailId !== null) {
      payload.grupo_email_id = grupoEmailId;
    }
    if (monitoramentoId !== undefined && monitoramentoId !== null) {
      payload.monitoramento_id = monitoramentoId;
    }

    return this.http.post(url, payload);
  }

  // GET /api/monitoramento - Lista com filtros
  listar(
    estacao_id?: number,
    status?: number,
    data_inicio?: string,
    data_fim?: string,
    page?: number,
    per_page?: number
  ): Observable<any> {
    let params = new HttpParams();
    
    if (estacao_id) params = params.set('estacao_id', estacao_id.toString());
    if (status !== undefined) params = params.set('status', status.toString());
    if (data_inicio) params = params.set('data_inicio', data_inicio);
    if (data_fim) params = params.set('data_fim', data_fim);
    if (page) params = params.set('page', page.toString());
    if (per_page) params = params.set('per_page', per_page.toString());
    
    return this.http.get(`${this.url_base}/${this.prefixo}`, { params });
  }

  // GET /api/monitoramento/{id}
  buscar(id: number): Observable<any> {
    return this.http.get(`${this.url_base}/${this.prefixo}/${id}`);
  }

  // POST /api/monitoramento
  criar(monitoramento: any): Observable<any> {
    return this.http.post(`${this.url_base}/${this.prefixo}`, monitoramento);
  }

  // PUT /api/monitoramento/{id}
  atualizar(id: number, dados: any): Observable<any> {
    return this.http.put(`${this.url_base}/${this.prefixo}/${id}`, dados);
  }

  // DELETE /api/monitoramento/{id}
  excluir(id: number): Observable<any> {
    return this.http.delete(`${this.url_base}/${this.prefixo}/${id}`);
  }

  // POST /api/monitoramentos - Inserção em lote com eventos
  criarEmLote(monitoramentoComEventos: any): Observable<any> {
    return this.http.post(`${this.url_base}/monitoramentos`, monitoramentoComEventos);
  }

  // Método para abrir monitoramento
  abrirMonitoramento(id: number, observacao: string, email_para?: string): Observable<any> {
    const dados = {
      status: 0,
      observacao_abertura: observacao,
      email_para: email_para,
      data_hora_ultima_situacao: new Date().toISOString()
    };
    return this.atualizar(id, dados);
  }

  // POST /api/monitoramento-eventos - Criar evento de monitoramento
  criarEvento(evento: any): Observable<any> {
    return this.http.post(`${this.url_base}/monitoramento-eventos`, evento);
  }

  // PUT /api/monitoramento-eventos/{id} - Atualizar evento de monitoramento
  atualizarEvento(id: number, evento: any): Observable<any> {
    return this.http.put(`${this.url_base}/monitoramento-eventos/${id}`, evento);
  }

  validarAbertura(
    estacaoId: number,
    dataInicio: string,
    dataFim?: string | null,
    monitoramentoId?: number | null
  ): Observable<any> {
    let params = new HttpParams()
      .set('estacao_id', estacaoId.toString())
      .set('data_inicio', dataInicio);

    if (dataFim) {
      params = params.set('data_fim', dataFim);
    }
    if (monitoramentoId) {
      params = params.set('monitoramento_id', monitoramentoId.toString());
    }

    return this.http.get(`${this.url_base}/${this.prefixo}/validar-abertura`, { params });
  }

  /**
   * Busca detalhes completos de um monitoramento
   * GET /api/monitoramento/{id}/detalhes
   */
  obterDetalhes(monitoramentoId: number): Observable<any> {
    return this.http.get(`${this.url_base}/${this.prefixo}/${monitoramentoId}/detalhes`);
  }

}
